export default function LinkArrow() {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.39993 8.59991L8.59992 1.3999M8.59992 1.3999L1.3999 1.3999M8.59992 1.3999V8.59992"
                  stroke="inherit"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}
